import { default as en } from './en/translations.json'

export default {
	en
}
